import { render, staticRenderFns } from "./smallWaveCourse.vue?vue&type=template&id=0545635a&scoped=true"
import script from "./smallWaveCourse.vue?vue&type=script&lang=js"
export * from "./smallWaveCourse.vue?vue&type=script&lang=js"
import style0 from "./smallWaveCourse.vue?vue&type=style&index=0&id=0545635a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0545635a",
  null
  
)

export default component.exports